import { useMemo } from 'react';
import { find, merge } from 'lodash';
import { ReservCell } from 'entities/Reservations';

import BookingHelper from '../utils';

type Columns = {
  title: string;
  dataIndex: string;
  key: string;
  width: number;
};

export const usePrepareGrid = (
  data: ReservCell[] | null,
  headers: Columns[],
  times: any,
  lockedCell: any,
  isManager: any,
  user: any,
) =>
  useMemo(() => {
    const prepareData: any = [];

    if (data) {
      times.map((time: string) => {
        const obj = { time };

        headers.forEach((head) => {
          const bookinksToday = data.filter((singleBook: any) => {
            const fromDate = BookingHelper.formatDate(singleBook.bookingDate);
            const inTime = BookingHelper.formatTime(singleBook.bookingDate);
            if (isManager && user !== singleBook.reservationOwner.name) {
              singleBook!.bookingStatus = 5;
            }
            return fromDate === head.dataIndex && time === inTime;
          });
          const cancaledDates = find(
            lockedCell,
            (cell: any) => BookingHelper.formatTime(cell.from) === time && cell.isNotBookable,
          );
          const disabledDates = lockedCell.filter(
            (cell: any) =>
              BookingHelper.formatTime(cell.from) === time &&
              BookingHelper.formatDate(cell.from) === head.dataIndex &&
              (cell.isBlocked === true ||
                cell.isNotBookable === true ||
                cell.isWeekendNotBookable === true ||
                cell.isTomorrowNotBookable === true),
          );
          if (head.dataIndex !== 'time') {
            // @ts-ignore
            obj[head.dataIndex] = bookinksToday;
            if (cancaledDates !== undefined) {
              // @ts-ignore
              obj[head.dataIndex] = merge(bookinksToday, cancaledDates);
            }
            if (
              disabledDates !== undefined &&
              disabledDates[0]?.from !== undefined &&
              BookingHelper.formatTime(disabledDates[0]?.from) === obj.time &&
              BookingHelper.formatDate(disabledDates[0]?.from) === head.dataIndex
            ) {
              if (head.dataIndex) {
                // @ts-ignore
                obj[head.dataIndex] = merge(bookinksToday, disabledDates);
              }
            }
          }
        });
        return prepareData.push(obj);
      });
    }
    prepareData.pop();
    return prepareData;
  }, [data, headers, times, lockedCell]);
